import { SVGProps } from 'react';

const ChartScaleMediumKindLine = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M21.0001 21H3M19.0001 8L15.0812 12.1827C14.9327 12.3412 14.8585 12.4204 14.7689 12.4614C14.6898 12.4976 14.6027 12.5125 14.5161 12.5047C14.418 12.4958 14.3216 12.4458 14.1288 12.3457L10.8714 10.6543C10.6786 10.5542 10.5822 10.5042 10.4841 10.4953C10.3975 10.4875 10.3104 10.5024 10.2313 10.5386C10.1417 10.5796 10.0675 10.6588 9.91897 10.8173L6.0001 15"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ChartScaleMediumKindLine;
